import { Segment } from '@fixter/i18n';
import type { CmsPageCollectionItems, CmsCarMakeItem } from '$cms/types';

interface LinkObject {
  readonly name: string;
  readonly link: string;
}

export function makePopularMakeLink(
  pageCollectionItems: CmsPageCollectionItems,
  collectionItem: Pick<CmsCarMakeItem, 'name' | 'slug'>,
  segment?: Segment
): LinkObject {
  const { product, area, ...others } = pageCollectionItems;

  const frSegment = segment === Segment.Fixter_FR;

  const { slug } = collectionItem;
  let { name } = collectionItem;
  let link = `/${slug}`;

  if ((!Object.keys(others).length && product) || (product && area)) {
    name = frSegment ? `${product.name} ${name}` : `${name} ${product.name}`;
    link = `/${product.slug}/${slug}`;
  }

  return {
    name,
    link,
  };
}
